import { PopupStoreDetailPage } from './PopupStoreDetailPage';

export const popupStoreDetailRouter = {
  '/@/popup-store/:popup_id': PopupStoreDetailPage,
};
